import { render } from "./PropertyDetailsModal.vue?vue&type=template&id=2bccdbe9&scoped=true"
import script from "./PropertyDetailsModal.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsModal.vue?vue&type=script&lang=js"

import "./PropertyDetailsModal.vue?vue&type=style&index=0&id=2bccdbe9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bccdbe9"]])

export default __exports__